import { SITE_COLOR } from "src/domains/shared/constants/styles/site";

/** 사이트 버튼(시안 `.btn` — 레포 Button medium 36/16px·large 44/20px, 모서리 6) */
const BUTTON_BASE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  borderRadius: "var(--r-btn)",
  fontWeight: 600,
  whiteSpace: "nowrap",
  transition:
    "background-color .15s ease,border-color .15s ease,color .15s ease,transform .15s ease",
  "&:active": { transform: "scale(.98)" },
} as const;

const MEDIUM = {
  height: "36px",
  padding: "0 16px",
  fontSize: "14px",
  letterSpacing: ".4px",
} as const;
const LARGE = {
  height: "44px",
  padding: "0 20px",
  fontSize: "15px",
  fontWeight: 700,
  letterSpacing: ".46px",
} as const;

const PRIMARY = {
  background: SITE_COLOR.blue,
  color: "#fff",
  "&:hover": { background: SITE_COLOR.blueDark },
} as const;

const OUTLINE = {
  border: "1px solid rgba(29,116,255,.5)",
  color: SITE_COLOR.blue,
  "&:hover": { background: SITE_COLOR.blueAlpha },
} as const;

const GREY = {
  background: "#fff",
  color: SITE_COLOR.ink,
  border: `1px solid ${SITE_COLOR.line}`,
  "&:hover": { background: SITE_COLOR.grey100 },
} as const;

export const SITE_BUTTON_STYLES = {
  primaryMedium: { ...BUTTON_BASE, ...MEDIUM, ...PRIMARY },
  primaryLarge: { ...BUTTON_BASE, ...LARGE, ...PRIMARY },
  outlineMedium: { ...BUTTON_BASE, ...MEDIUM, ...OUTLINE },
  outlineLarge: { ...BUTTON_BASE, ...LARGE, ...OUTLINE },
  greyLarge: { ...BUTTON_BASE, ...LARGE, ...GREY },
} as const;

/** 글자 링크 + 오른쪽 화살표(시안 `.link-arrow`) */
export const SITE_LINK_ARROW_STYLES = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  fontWeight: 600,
  color: SITE_COLOR.blueDark,
  "& svg": { transition: "transform .2s cubic-bezier(.2,.75,.25,1)" },
  "&:hover svg": { transform: "translateX(3px)" },
} as const;
